import React, { useState } from "react";
import images from "../../../../Utils/importImages";
import { Button, TextField } from "@mui/material";
import { RegisterUserMain } from "../../../../Redux/Apis/User-Apis";
import { useSelector } from "react-redux";

function SetPassword({ onClose, credential, credentialType }) {
  // The actually-selected region/pipeline (set by the region dropdown in Header.jsx) — must be
  // sent with the final create-user call instead of leaving it out (this is the step that
  // actually inserts the `users` row).
  const selectedPipelineId = useSelector((state) => state.user.selectedPipelineId);
  const [password, setPassword] = useState("");
  const [userName, setUserName] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [UserNameError, setUserNameError] = useState("");

  const onChangeInput = (type, val) => {
    if (type == "password") {
      validatePassword(val);
      setPassword(val);
    } else {
      setUserName(val);
    }
  };

  const handleSubmit = async () => {
    let struc = {
      identifier: credential,
      name: userName,
      password: password,
      pipeline_id: selectedPipelineId,
    };

    let resp = await RegisterUserMain(struc );
    if (resp.error == true) {
      return;
    }

    onClose("Register", { identifier: credential, password: password }); // at there perform auto login
 
  };

  const validatePassword = (value) => {
    const passwordRegex =
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/;

    if (!value) {
      setPasswordError("*Required");
      return false;
    }
    if (!passwordRegex.test(value)) {
      setPasswordError(
        "Password must be at least 6 characters long and include a mix of letters, numbers, and symbols (@$!%*#?&)"
      );
      return false;
    }

    setPasswordError("");
    return true;
  };

  const validateUserName = (value) => {
    if (!value) {
      setUserNameError("*Required");
      return false;
    }

    setUserNameError("");
    return true;
  };

  return (
    <div className="register-login">
      <div className="header">
        <img
          src={images["user-login-icon.svg"]}
          alt=""
          className="login-icon"
        />
        <div className="title proxima_semibold color_black font22">
          Profile Details
        </div>
      </div>

      {/* <div className="otp proxima_semibold color_black font12">
        Enter New Password for {credentialType.toUpperCase()} : {credential}
      </div> */}

      <div className="input-content">
        <TextField
          autoComplete="off"
          error={!!UserNameError}
          helperText={UserNameError}
          value={userName}
          onChange={(e) => onChangeInput("name", e.target.value)}
          onBlur={() => validateUserName(userName)}
          id="outlined-basic"
          label="Enter Full Name"
          variant="outlined"
          size="small"
          sx={{
            width: "100%",
            "& .MuiInputLabel-root": {
              fontSize: "16px",
              fontFamily: `var(--font-family-proxima_nova-regular)`,
              fontStyle: "normal",
              fontWeight: "400",
              "&.Mui-focused": {
                color: "#0057B7",
              },
            },
            "& .MuiOutlinedInput-root": {
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#0057B7",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#0057B7",
              },
            },
          }}
        />
      </div>

      <div className="input-content">
        <TextField
          autoComplete="off"
          error={!!passwordError}
          helperText={
            passwordError ||
            "Use 6 or more characters with a mix of letters, numbers & symbols (@$!%*#?&"
          }
          value={password}
          onChange={(e) => onChangeInput("password", e.target.value)}
          id="outlined-basic"
          label="Enter Password"
          variant="outlined"
          size="small"
          sx={{
            width: "100%",
            "& .MuiInputLabel-root": {
              fontSize: "16px",
              fontFamily: `var(--font-family-proxima_nova-regular)`,
              fontStyle: "normal",
              fontWeight: "400",
              "&.Mui-focused": {
                color: "#0057B7",
              },
            },
            "& .MuiOutlinedInput-root": {
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "#0057B7",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "#0057B7",
              },
            },
          }}
        />
      </div>

      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        disabled={!password || !userName || !!passwordError || !!UserNameError}
        sx={{
          width: "100%",
          backgroundColor: "#0057B7",
          color: "#fff",
          fontSize: "16px",
          fontFamily: `var(--font-family-proxima_nova-semibold)`,
          //   fontWeight: "00",
          marginTop: "10px",
          textTransform: "none",
          "&:hover": { backgroundColor: "#0045A5" },
          "&:disabled": {
            backgroundColor: "#B0B0B0",
            color: "#fff",
            cursor: "not-allowed",
          },
        }}
      >
        SAVE AND EXIT
      </Button>

      <div className="tandc color_light-gray-black font14 proxima_regular">
        By proceeding, you agree to TripPrizer's{" "}
        <span className="color_endeavour">Privacy Policy, User Agreement</span>{" "}
        and <span className="color_endeavour">T&Cs</span>
      </div>
    </div>
  );
}

export default SetPassword;
